/**
 * URLs das lojas de aplicativos do Voopter.
 * Fonte única: rodapé, home e faixa do app em alertas usam estas constantes.
 */
export const APP_STORE_URLS = {
  /** Página direta do app na App Store (Brasil). */
  ios: "https://apps.apple.com/br/app/voopter-pre%C3%A7os-de-voos/id849215105",
  /** Página direta do app na Play Store (pacote `com.voopter`). */
  android: "https://play.google.com/store/apps/details?id=com.voopter",
} as const;
